import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "bs_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const copy = [...cur];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + qty };
        return copy;
      }
      return [...cur, {
        product_id: product.id,
        name: product.name,
        price: product.price,
        image: (product.images || [])[0],
        stock: product.stock,
        quantity: qty,
      }];
    });
  };
  const remove = (product_id) => setItems((c) => c.filter((i) => i.product_id !== product_id));
  const update = (product_id, quantity) =>
    setItems((c) => c.map((i) => (i.product_id === product_id ? { ...i, quantity: Math.max(1, quantity) } : i)));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, update, clear, count, total }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
